import Layout from '@/layout'

// AI中心路由
export const ai = [
  {
    path: '/ai/manage',
    component: Layout,
    redirect: '/ai/manage/chat',
    name: 'AIManage',
    alwaysShow: true,
    meta: {
      title: 'AI管理',
      icon: 'permission',
      permission_uri: '/ai/manage'
    },
    children: [{
      path: 'chat',
      name: 'AIChat',
      component: () => import('@/views/ai/manage/chat'),
      meta: {
        title: 'AI聊天',
        icon: 'user',
        permission_uri: '/ai/manage/chat'
      }
    }]
  },
  {
    path: '/ai/permission',
    component: Layout,
    redirect: '/ai/permission/member',
    name: 'AIPermission',
    alwaysShow: true,
    meta: {
      title: '权限管理',
      icon: 'permission',
      permission_uri: '/ai/permission'
    },
    children: [{
      path: 'member',
      name: 'AIPermissionMember',
      component: () => import('@/views/ai/permission/member'),
      meta: {
        title: '成员管理',
        icon: 'user',
        permission_uri: '/ai/permission/member'
      }
    }]
  }
]
